import {Estimator, Project} from "../../../../api/Projects";
import {
    DialogContent,
    DialogTitle, IconButton,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText
} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {api} from "../../../../api/API";
import {useAsyncAction} from "nate-react-api-helpers";
import {useSyncedRef} from "../../../../misc/SyncedRef";
import {useState} from "react";
import {AutoComplete} from "../../shopdrawing/openings/AutoComplete";
import {User} from "../../../../api/Users";
import {Delete} from "@mui/icons-material";

export function MultiUsrEdit(props: {
    value: Project;
    onDone(): void;
}) {

    const onDoneRef = useSyncedRef(props.onDone);
    const update = useAsyncAction(async input => {
        await api.projects.upsert(input)
        onDoneRef.current();
    }, [])

    const [contacts, setContacts] = useState<Estimator[]>(props.value.estimators || []);

    const submit = () => {
        update.callback(Object.assign({}, props.value, {
            estimators: contacts
        }));
    };

    return (
        <Dialog2 open onClose={props.onDone} onEnterPress={submit}>
            <DialogTitle>Choose Estimators</DialogTitle>
            <DialogContent>
                <div style={{height: 8}} />

                <List dense>
                {contacts.filter(v => !v.archived).map(v => (
                    <ListItem>
                        <ListItemText primary={v.name} />
                        <ListItemSecondaryAction>
                            <IconButton onClick={() => {
                                setContacts(old => {
                                    return old.map(itm => {
                                        if(itm === v) {
                                            return Object.assign({}, v, {archived: true})
                                        }

                                        return itm;
                                    })
                                });
                            }}>
                                <Delete />
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                ))}
                </List>

                <AutoComplete<User>
                    label="Find Person"
                    search={async input => {
                        const result = await api.users.list({
                            search: input,
                            offset: 0,
                            permission: "Estimator",
                        })

                        return result.data.filter(v => !contacts.some(v2 => v2.person === v.id));
                    }}
                      value={null}
                      equals={(a, b) => a.id === b.id}
                      makeLabel={a => a.name}
                      onSelect={v => setContacts(old => {
                          const upd = old.filter(v => v.person !== v.id);
                          return [...upd, {
                              id: 0,
                              person: v.id,
                              name: v.name,
                          }] as any;
                      })}
                />

            </DialogContent>
            <SmoothActionBar
                loading={update.loading}
                error={update.error}
                onCancel={props.onDone}
                onSubmit={submit}
            />
        </Dialog2>
    )
}